export var carinaFontReset = function(theme) {
    return {
        fontFamily: theme.font.base.family,
        fontStyle: 'normal',
        fontWeight: theme.font.base.weight.regular,
        letterSpacing: 'normal',
        textAlign: 'center',
        textIndent: 0,
        textShadow: 'none',
        textTransform: 'none'
    };
};
